export const languageChanged = () => ({ type: 'LANGUAGE_CHANGED' });

export const errChangeLanguage = () => ({ type: 'CHANGE_LANGUAGE_ERR' });
